module.exports = __webpack_public_path__ + "static/media/hk.9b3e36f4.svg";